// @ts-nocheck




import React from 'react';

import { maintenanceOperationGroupApi } from '../../lib/api';

import AutocompleteSelect from './AutocompleteSelect';

export default (selectProps) =>
<AutocompleteSelect
  placeholder="Выберите виды работ"
  fetch={async (params) =>
  await maintenanceOperationGroupApi.fetchMaintenanceOperationGroups({
    ...params
  })
  }
  fetchSingle={maintenanceOperationGroupApi.fetchMaintenanceOperationGroup}
  notFoundText="Виды работ не найдены"
  renderOption={(maintenanceOperation, Option) =>
  <Option
    key={maintenanceOperation.id}
    value={maintenanceOperation.id}
    maintenanceoperation={maintenanceOperation}>

        {maintenanceOperation.name}
      </Option>
  }
  {...selectProps} />;
